/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-shuffle': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.119 12.131l2.237 2.244H12.22L9.488 10l2.73-4.375h4.138L14.12 7.869l.88.881L18.75 5 15 1.25l-.881.881 2.237 2.244H12.22a1.25 1.25 0 00-1.056.588L8.75 8.819 6.338 4.962a1.25 1.25 0 00-1.057-.587H1.25v1.25h4.031L8.012 10l-2.73 4.375H1.25v1.25h4.031a1.25 1.25 0 001.057-.588l2.412-3.856 2.412 3.857a1.25 1.25 0 001.057.587h4.137l-2.237 2.244.881.881L18.75 15 15 11.25l-.881.881z"/>'
  }
})
